import React, { forwardRef } from "react"
import { filterDomProps } from "./dom-props"
import { flattenStyle } from "./style"

type RNStyle = Record<string, unknown> | RNStyle[] | null | undefined | false

export type WebTextProps = Omit<React.HTMLAttributes<HTMLSpanElement>, "style"> & {
  numberOfLines?: number
  ellipsizeMode?: "head" | "middle" | "tail" | "clip" | string
  testID?: string
  style?: RNStyle
}

const lineClampBase: React.CSSProperties = {
  display: "block",
  maxWidth: "100%",
  minWidth: 0,
}

function lineClampStyle(numberOfLines?: number, ellipsizeMode?: string): React.CSSProperties | undefined {
  if (!numberOfLines || numberOfLines <= 0) return undefined

  if (numberOfLines === 1) {
    return {
      ...lineClampBase,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: ellipsizeMode === "middle" ? "clip" : "ellipsis",
    }
  }

  return {
    ...lineClampBase,
    display: "-webkit-box",
    WebkitLineClamp: numberOfLines,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    whiteSpace: "normal",
  }
}

/** H5 Text：支持 RN 的 numberOfLines / ellipsizeMode */
export const WebText = forwardRef<HTMLSpanElement, WebTextProps>(function WebText(
  { numberOfLines, ellipsizeMode, style, testID, children, ...props },
  ref,
) {
  return (
    <span
      ref={ref}
      className="rn-text"
      data-testid={testID}
      style={{
        ...lineClampStyle(numberOfLines, ellipsizeMode),
        ...flattenStyle(style),
      }}
      {...(filterDomProps(props as Record<string, unknown>) as React.HTMLAttributes<HTMLSpanElement>)}
    >
      {children}
    </span>
  )
})
